import { pathJoin } from '../../../utils'
import { createCollectionCalendarRoutesMap } from './collection-calendar'

export const createProjectIdRoutesMap = (prefix: string) => ({
  'collection-calendar': pathJoin(prefix)('collection-calendar').chainMapAuto(
    createCollectionCalendarRoutesMap
  ),
})
